// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1_mtM","productName":"Table_productName__3apkV"};